import "./Profile2.css";
import {motion} from "framer-motion";
//<img src="https://image.api.playstation.com/vulcan/img/rnd/202010/1520/F1WFbqD8WCEWYGErUSk1OAOf.png" />
export default function Profile2(){
    return (
        <div className="containerB" data-aos="fade-up">
            <div className="bg-bat">
                <div className="bg-bat2">
                    <motion.img src="https://raw.githubusercontent.com/Apurv-07/home/master/images/Captain-America-PNG-HD.png" initial={{scale:0}} animate={{scale:[0.2, 0.6, 1, 1.4, 1, 1.2, 1]}} />
                </div>
            </div>
            <div className="bg-text">
                <h1>About Me</h1>
                <p>I'm Apurva Prakash. I'm a web developer currently working at Cognizant, with a work experience of 1 year and 2 months in the IT industry. I've worked on numerous projects on Node js, React js and firebase/mongodb. My strength is that I like challenges, I like to play with codes, I'm a DIY guy and I always want to learn and explore new things. I'm higly adoptable person and a good team player. I enjoy watching movies a lot.</p>

            </div>
        </div>
    )
}